export const toNum = (v: unknown): number => {
  if (typeof v === 'number' && !Number.isNaN(v)) return v;
  const s = String(v).trim();
  if (s === '') return 0;
  if (/,\d*$/.test(s)) return Number(s.replace(/\./g, '').replace(',', '.')) || 0;
  return parseFloat(s) || 0;
};

export const formatCurrency = (value: unknown): string =>
  toNum(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const formatDateBR = (dateString?: string | null): string => {
  if (!dateString) return '—';
  const d = String(dateString).split('T')[0];
  const [y, m, day] = d.split('-');
  if (!y || !m || !day) return d;
  return `${day}/${m}/${y}`;
};

export const sanitizeFileLabel = (label: string): string =>
  label.replace(/[/:\\s]+/g, '-').replace(/[^\w\-().]/g, '');
